import GA4React from 'ga-4-react';

const gaKey = import.meta.env.VITE_GOOGLE_ANALYTICS;
const env = import.meta.env.VITE_ENV;

let ga4react;

export class GAService {
  static GA_TRACKING_ID = gaKey;

  static init = async () => {
    if (!GA4React.isInitialized() && GAService.GA_TRACKING_ID) {
      const isProd = env === 'PRODUCTION';
      ga4react = new GA4React(GAService.GA_TRACKING_ID, {
        debug_mode: !isProd,
      });
      try {
        await ga4react.initialize();
        GAService.pageview();
      } catch (error) {
        console.error(error);
      }
    }
  };

  static pageview = () => {
    try {
      ga4react.pageview(window.location.pathname);
    } catch (error) {
      // console.log("error:", error)
    }
  };

  static event = ({ action, category, label }) => {
    try {
      ga4react.event(action, label, category);
    } catch (error) {
      // console.log("error:", error)
    }
  };
}
